import React, { useContext } from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';
import { TableContext } from '../../contexts/TableContext';

const Table: React.FC = () => {
  const { stickyHeader } = useContext(TableContext);
  return (
    <table
      className="datatables-users table obs-table dataTable no-footer dtr-column"
      style={stickyHeader ? { tableLayout: 'fixed' } : undefined}
    >
      <TableHead />
      <TableBody />
    </table>
  );
};

export default Table;
